import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { SlackIntegrationSection } from '@webapp/platform/integrations/feature-sets/SlackIntegrationSection'
import messages from './messages'
import { useSlackIntegrationPage } from './useSlackIntegrationPage'

export const SlackIntegrationPage = () => {
  const intl = useProcurifyIntl()
  const { breadcrumbs } = useSlackIntegrationPage()

  const pageTitle = intl.formatMessage(messages.pageTitle)

  return (
    <Page pageTitle={pageTitle} breadcrumbs={breadcrumbs}>
      <SlackIntegrationSection />
    </Page>
  )
}
